module.exports = __webpack_public_path__ + "27f48e013ddd73710270e2d9224eb190.MP3";